module.exports = __webpack_public_path__ + "static/media/cozy.68377b4a.png";